@if (gitlabIssues.length === 0) {
  <p
    class="op-tab-content--text-box"
    [innerHTML]="getEmptyText()"
  ></p>
}

@for (gitlabIssue of gitlabIssues; track gitlabIssue.id || gitlabIssue.htmlUrl) {
  <gitlab-issue [gitlabIssue]="gitlabIssue" />
}
